/////////////////////////////////////////////////////////////
import { Checked, Unchecked } from '@/app/shared/components';
import { Option } from '@/core/interfaces';

interface SettingOptionProps {
	option: Option;
	isChecked: boolean;
	onSelectOption: (option: Option) => void;
}

export const SettingOption: React.FC<SettingOptionProps> = ({
	option,
	isChecked,
	onSelectOption,
}: SettingOptionProps) => {
	/*********************
	// #region Template
	**********************/

	const { name, image } = option;

	return (
		<div
			className="flex rounded-2xl items-center bg-customer-900/70 px-5 py-4 option-menu-setting "
			onClick={() => {
				onSelectOption(option);
			}}
		>
			{image ? (
				<div className="flex flex-row w-full gap-3 items-center">
					<img src={image} className="w-[30px]" />
					<p className="text-base font-bold">{name}</p>
				</div>
			) : (
				<div className="flex flex-row w-full gap-3 items-center">
					<p className="text-base font-bold">{name}</p>
				</div>
			)}

			<div className="flex flex-col items-center self-center">
				{isChecked ? <Checked /> : <Unchecked />}
			</div>
		</div>
	);
};
